import React, {useEffect } from 'react'; 
import { Link } from 'react-router-dom'
import Header from "../Component/Header";
const HomeworkSchedule = () => {
    useEffect(() => {
        document.title = 'Homework Schedule -  The Air Force School Subroto Park';  
    }, []);  
  return (
     <>
       <Header/>
<div className="innerslide">
            <ul className="breadcrumb">
                <li><Link to="/"> Home</Link> </li> 
                <li> Academics  </li> 
                 <li>Homework Schedule</li>
            </ul>
        </div> 
        <div className="innersec">
            <div className="container">
                <div className="row">
                    <div className="col-lg-12">
                        <h1> Homework Schedule </h1>
                    </div>
                </div>
                <div className="row">
                    <div className="col-lg-12">
                         <h6>Senior School (VI - X)</h6>
                         <p> Dear Parent, </p> 
                         <p>Greetings of the day! </p> 
                         <p> Homework plays a significant role in a child's education, and it ensures that academics are consistent at home. In order to ensure that students are able to make a balance with all other activities, one home work is assigned each day. </p> 
                         <p>The H.W. Schedule is as follows:</p>
                         <div className="table-responsive maintable">
                         <table className="table">
                            <thead>
                                    <tr align="center"> 
                                        <th>Class/Sub </th>
                                        <th>VI </th>
                                        <th>VII </th>
                                        <th>VIII </th>
                                        <th>IX </th>
                                        <th>X </th> 
                                    </tr>
                                </thead>
                                <tbody> 
                                <tr>
                                <td>Monday</td>
                                <td>English</td>
                                <td>S.St.</td>
                                <td>Science</td>
                                <td>Maths</td>
                                <td>Hindi</td>
                            </tr>
                            <tr>
                                <td>Tuesday</td>
                                <td>Hindi/Skt</td>
                                <td>English</td>
                                <td>S.St.</td>
                                <td>Science</td>
                                <td>Maths</td>
                            </tr>
                            <tr>
                                <td>Wednesday</td>
                                <td>Maths</td>
                                <td>Hindi/Skt</td>
                                <td>English</td>
                                <td>S.St.</td>
                                <td>Science</td>
                            </tr>
                            <tr>
                                <td>Thursday</td>
                                <td>Science</td>
                                <td>Maths</td>
                                <td>Hindi/Skt</td>
                                <td>English</td>
                                <td>S.St.</td>
                            </tr>
                            <tr>
                                <td>Friday</td>
                                <td>S.St.</td>
                                <td>Science</td>
                                <td>Maths</td>
                                <td>Hindi</td>
                                <td>English</td>
                            </tr>
                                </tbody>
                        </table>
                    </div>
                    <p><b>Kindly note:</b></p>
                    <ul className="list"> 
                    <li>Homework can be viewed on the portal of your ward.</li>
                    <li>Each homework carries certain weightage which is included in the marks of internal assessment.</li>
                    <li>Please ensure your ward completes the home work in neat and presentable manner and submits it on time.</li>
                    </ul>
                    <p>Thanks for your cooperation. </p>

                        <p>Warm regards  <br/>

                        (Lomina Rajiv) <br/>
                        Principal </p>
                        <h6>Junior School (I - V)</h6>
                        <p><b>1. </b> No homework will be given to Classes I-II. However,one Follow up activity will be given daily.  Practice worksheets in 2 subjects will also be uploaded every working Friday on the portal. </p> 
                        <p><b>2. </b> The schedule for homework for classes III to V is as follows: </p>
                        <div className="table-responsive maintable">
                                    <table className="table">
                                    <thead>
                                            <tr align="center">  
                                                <th>DAYS </th>
                                                <th>   SUBJECTS </th>
                                            </tr>
                                    </thead>
                                    <tbody>
                                    <tr>
                                    <td> MONDAY </td>
                                    <td> ENGLISH </td>
                                    </tr> 
                                    <tr> 
                                    <td> TUESDAY </td>
                                    <td> HINDI </td>
                                    </tr>
                                    <tr> 
                                    <td> WEDNESDAY </td>
                                    <td> MATH </td>
                                    </tr> 
                                    <tr>
                                    <td> THURSDAY </td>
                                    <td> EVS </td>
                                    </tr>
                                    <tr> 
                                    <td> FRIDAY </td>
                                    <td> PRACTICE&  WORKSHEETS OF 2 SUBJECTS ON PORTAL </td>
                                    </tr> 
                                    </tbody>
                                    </table>
                                    </div>
                    </div>
                </div>
            </div>
        </div>
     </>
  )
}

export default HomeworkSchedule